import { render, staticRenderFns } from "./buyInfo.vue?vue&type=template&id=9a412cd4&"
import script from "./buyInfo.vue?vue&type=script&lang=js&"
export * from "./buyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports